import accordionGroup from './accordion-group';
export default accordionGroup;
